import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';
import { adminApi } from '../lib/api';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await adminApi.post('/admin/login', { username: username.trim(), password });
      localStorage.setItem('adminToken', r.data.token);
      localStorage.setItem('adminUser', JSON.stringify(r.data.admin || {}));
      toast.success(`Welcome back, ${r.data.admin?.name || 'Admin'}!`);
      navigate('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center hero-bg px-4 py-10">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#6b7280] mb-8 hover:text-[#0a0a0a]" data-testid="back-to-home">
          <ArrowLeft size={16} /> Back
        </Link>
        <div className="card p-8 sm:p-10">
          <Logo size="lg" />
          <div className="mt-6 mb-8">
            <h1 className="text-2xl font-semibold mb-2">Admin Console</h1>
            <p className="text-sm text-[#6b7280]">Sign in with your admin credentials</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-[#1f1f1f] mb-1.5 tracking-wide uppercase">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
                data-testid="admin-username-input"
                className="w-full px-4 py-2.5 border border-[#e7e7e7] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d92027] focus:border-[#d92027] text-sm"
                placeholder="your username"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-[#1f1f1f] mb-1.5 tracking-wide uppercase">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                data-testid="admin-password-input"
                className="w-full px-4 py-2.5 border border-[#e7e7e7] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#d92027] focus:border-[#d92027] text-sm"
                placeholder="••••••••"
              />
            </div>
            <button type="submit" disabled={loading} className="w-full btn-brand disabled:opacity-50 flex items-center justify-center gap-2 mt-6" data-testid="admin-login-submit">
              <Lock size={14} /> {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-[#6b7280] mt-6">
          Customer? <Link to="/customer/login" className="text-[#d92027] font-semibold">Sign in here</Link>
        </p>
      </div>
    </div>
  );
}
